import { render, staticRenderFns } from "./RoleLayer.vue?vue&type=template&id=e84b393a&"
import script from "./RoleLayer.vue?vue&type=script&lang=js&"
export * from "./RoleLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e84b393a')) {
      api.createRecord('e84b393a', component.options)
    } else {
      api.reload('e84b393a', component.options)
    }
    module.hot.accept("./RoleLayer.vue?vue&type=template&id=e84b393a&", function () {
      api.rerender('e84b393a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/components/layer/RoleLayer.vue"
export default component.exports